import { render, staticRenderFns } from "./InvoiceRow.vue?vue&type=template&id=4acb3b2c&"
import script from "./InvoiceRow.vue?vue&type=script&lang=js&"
export * from "./InvoiceRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports